import React from 'react'

const CustomerFeedback = () => {
  return (
    <>
 <section className="testimonial-area">
  <div className="container">
    <div className="sec-title text-center">
      <h2>Customers Feedback</h2>
      <span className="border" />
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="testimonials-carousel">
          {/*Start single slide item*/}
          <div className="single-slide-item">
            <div className="img-box">
              <img src="images/customers/gallery.jpg" alt="Awesome Image" />
              <div className="client-photo">
                <img src="images/customers/Profile.png" alt="Awesome Image" />
              </div>
              <div className="review-box">
                <span>Project Rating:</span>
                <ul>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                </ul>
              </div>
            </div>
            <div className="text-box">
              <span className="flaticon-right" />
              <div className="text">
                <p>Today we can tell you, thanks to your passion, hard work creativity, and expertise, you delivered us the most beautiful house ever! It’s been a beautiful ride, there were up’s and down’s, frustrations, delays at the same time great looks.</p>
                <h3>Astley Fletcher</h3>
                <h4>Newyork City</h4>
              </div>
            </div>
          </div>
          {/*End single slide item*/}
          {/*Start single slide item*/}
          <div className="single-slide-item">
            <div className="img-box">
              <img src="images/customers/gallery.jpg" alt="Awesome Image" />
              <div className="client-photo">
                <img src="images/customers/Profile.png" alt="Awesome Image" />
              </div>
              <div className="review-box">
                <span>Project Rating:</span>
                <ul>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                </ul>
              </div>
            </div>
            <div className="text-box">
              <span className="flaticon-right" />
              <div className="text">
                <p>Today we can tell you, thanks to your passion, hard work creativity, and expertise, you delivered us the most beautiful house ever! It’s been a beautiful ride, there were up’s and down’s, frustrations, delays at the same time great looks.</p>
                <h3>Astley Fletcher</h3>
                <h4>Newyork City</h4>
              </div>
            </div>
          </div>
          {/*End single slide item*/}
          {/*Start single slide item*/}
          <div className="single-slide-item">
            <div className="img-box">
              <img src="images/customers/gallery.jpg" alt="Awesome Image" />
              <div className="client-photo">
                <img src="images/customers/Profile.png" alt="Awesome Image" />
              </div>
              <div className="review-box">
                <span>Project Rating:</span>
                <ul>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                  <li><i className="fa fa-star" /></li>
                </ul>
              </div>
            </div>
            <div className="text-box">
              <span className="flaticon-right" />
              <div className="text">
                <p>Today we can tell you, thanks to your passion, hard work creativity, and expertise, you delivered us the most beautiful house ever! It’s been a beautiful ride, there were up’s and down’s, frustrations, delays at the same time great looks.</p>
                <h3>Astley Fletcher</h3>
                <h4>Newyork City</h4>
              </div>
            </div>
          </div>
          {/*End single slide item*/}
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default CustomerFeedback